<svg:g
    *ngIf="orientation == 'x'"
    class="x"
    attr.transform="translate(0, {{ dimensions.boundedHeight }})"
>
    <svg:line class="axis" [attr.x2]="dimensions.boundedWidth"></svg:line>
    <svg:text
        class="tick"
        *ngFor="let tick of ticks"
        [ngStyle]="{
            transform: [
                'translate(',
                scale(tick),
                'px, 10px)',
                'rotate(-45deg)'
            ].join('')
        }"
    >
        {{ formatTick(tick) }}
    </svg:text>
    <svg:line
        class="tick"
        *ngFor="let tick of ticks"
        [attr.y1]="-5"
        [attr.y2]="1"
        attr.transform="translate({{ scale(tick) }})"
    ></svg:line>
    <svg:text
        *ngIf="label"
        class="label"
        attr.transform="translate({{ dimensions.boundedWidth / 2 }}, 40)"
    >
        {{ label }}
    </svg:text>
</svg:g>
<svg:g *ngIf="orientation == 'y'" class="y">
    <svg:line class="axis" [attr.y2]="dimensions.boundedHeight"></svg:line>
    <svg:text
        *ngFor="let tick of ticks"
        class="tick"
        attr.transform="translate(-16, {{ scale(tick) }})"
    >
        {{ formatTick(tick) }}
    </svg:text>
    <svg:line
        class="tick"
        *ngFor="let tick of ticks"
        x1="-1"
        x2="2"
        attr.transform="translate(0, {{ scale(tick) }})"
    ></svg:line>
    <svg:text
        *ngIf="label"
        class="label"
        [ngStyle]="{
            transform: [
                'translate(-50px, ',
                dimensions.boundedHeight / 2,
                'px) rotate(-90deg)'
            ].join('')
        }"
    >
        {{ label }}
    </svg:text>
</svg:g>
